<header class="op-header">
  <nav uk-navbar>
    <div class="uk-navbar-left">
      @if (showPrimaryToggle() && primaryToggleToLeft()) {
        <span class="uk-navbar-item">
          <button opPrimarySidebarToggle></button>
        </span>
      }
      <span class="uk-navbar-item">
        <op-logo-selector [currentApp]="currentApp"></op-logo-selector>
      </span>
    </div>
    <div class="uk-navbar-right">
      @if (showAiButton()) {
        <span class="uk-navbar-item">
          <pros-ai-button [flowName]="aiButtonFlowName()" [context]="aiButtonContext()" [suggested]="aiButtonsSuggestions()" />
        </span>
      }
      <ng-content select="op-header-item"></ng-content>
      @if (showPrimaryToggle() && !primaryToggleToLeft()) {
        <span class="uk-navbar-item">
          <button opPrimarySidebarToggle class="right"></button>
        </span>
      }
    </div>
  </nav>
</header>
<op-environment-warning></op-environment-warning>
